import { Environments } from './constants'

export const isProduction = () => process.env.NODE_ENV === Environments.prod
